import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Import default React styles if present
import './styles.css'; // Import your custom styles
import App from './components/App';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const materialDesignShadow = '0px 2px 4px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.1)';

const theme = createTheme({
  palette: {
    primary: {
      main: '#A0522A', // Sienna brown color for primary buttons
      light: '#C8754A',
      dark: '#7A3F1F',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#A0522A', // Also apply to secondary buttons
      light: '#C8754A',
      dark: '#7A3F1F',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Jost, sans-serif',
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none', // Remove underline from links
          color: '#A0522A', // Set your preferred link color
          '&:hover': {
            color: '#A0522A', // Optional: Different color on hover
          },
          '&.button-style': {
            backgroundColor: '#A0522A',
            color: '#ffffff',
            padding: '12px 24px',
            borderRadius: '4px',
            textDecoration: 'none',
            display: 'inline-block',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#7A3F1F',
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: materialDesignShadow, // Standard Material Design shadow
          borderRadius: '4px', // Material Design cards typically have a 4px border radius
          elevation: 1, // Standard elevation for a resting card
          // Material Design specifies that cards should have a standard background color
          backgroundColor: '#FFFFFF', 
        },
      },
    },
    // Add Button component styles
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#A0522A',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#7A3F1F',
          },
          '&:active': {
            backgroundColor: '#5D2F17',
          },
        },
        outlined: {
          backgroundColor: 'transparent',
          color: '#A0522A',
          borderColor: '#A0522A',
          '&:hover': {
            backgroundColor: '#A0522A',
            color: '#ffffff',
            borderColor: '#A0522A',
          },
        },
        text: {
          backgroundColor: 'transparent',
          color: '#A0522A',
          '&:hover': {
            backgroundColor: 'rgba(160, 82, 42, 0.1)',
          },
        },
      },
    },
    // Override IconButton styles
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#A0522A',
          '&:hover': {
            backgroundColor: 'rgba(160, 82, 42, 0.1)',
          },
        },
      },
    },
    // Override Fab (Floating Action Button) styles
    MuiFab: {
      styleOverrides: {
        root: {
          backgroundColor: '#A0522A',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#7A3F1F',
          },
        },
      },
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
  document.getElementById('root')
);